(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
require('./plugins/scrollslow.js');
require('./plugins/browser.js');
require('./modules/topbar.js');


(function ($) {

    $(document).ready(function () {

        $g.navMenu = function () {
            var $ = jQuery;
            $('body').on('click', '.hamburger', function () {

                $(this).toggleClass('is-active');
                $('.menu-full').toggleClass('open');
                $('.body-cover').toggleClass('open');
                $('body').toggleClass('o-hidden');
                // $('.header-bar').toggleClass('header-bar--active');
            });


        };
        $g.navMenu();

        var $ = jQuery;
        $(".menu-full a").on("click", function() {

                $('.menu-full').removeClass('open');
                $('.body-cover').removeClass('open');
                $('body').removeClass('o-hidden');
                $('.hamburger').removeClass('is-active');

        });

        var faqScriptBlock = function() {

            var $ = jQuery;

            // ACCORDION AREAS
            $(".s-faq .js-group-faq > .js-head-faq").on("click", function() {
                // console.log('accoedion');
                if ($(this).hasClass("active")) {
                    $(this).removeClass("active");
                    $(this)
                        .siblings(".js-content-faq")
                        .slideUp(200);
                    // $(".js-group-faq > .js-head-faq .js-head-ico-faq")
                    //     .removeClass("minus")
                    //     .addClass("plus");
                    $(this)
                        .find(".js-head-ico-faq")
                        .removeClass("minus")
                        .addClass("plus");
                    // $('.js-group-faq').removeClass("active");
                    // $(this).parent('.js-group-faq').addClass("active");
                } else {
                    // $(".js-group-faq > .js-head-faq .js-head-ico-faq")
                    //     .removeClass("minus")
                    //     .addClass("plus");
                    $(this)
                        .find(".js-head-ico-faq")
                        .removeClass("plus")
                        .addClass("minus");
                    // $(".js-group-faq > .js-head-faq").removeClass("active");
                    $(this).addClass("active");
                    // $(".js-content-faq").slideUp(200);
                    $(this)
                        .siblings(".js-content-faq")
                        .slideDown(200);

                    // $('.js-group-faq').removeClass("active");
                    $(this).parent('.js-group-faq').addClass("active");
                }
            });
            // END ACCORDION AREAS

        }

        if (typeof window.acf !== 'undefined') {
            window.acf.addAction('render_block_preview/type=faq', faqScriptBlock);
        } else {
            faqScriptBlock();
        }



        /**** THE SCROLLSLOW - START ****/
        /** https://code.karol-drag.eu/scrollSlow/ **/
        if (typeof $g.scrollSlow !== 'undefined' && $('.header').length > 0) {
            //var marginTop = ($(window).width() > 1024) ? $('.header').outerHeight() : 0;
            var marginTop = $('.header').outerHeight();
            // var marginTop = 0;
            if (!$('body').hasClass('wp-admin')) {
                $g.scrollSlow({
                    speed: 1200,
                    top: marginTop,
                    //active: 'menu-item--active',
                    /*link: '.menu-link',*/
                    link: '*:not(.tab-btn):not(.js-enter-tab)',
                    //element: '.header-menu .menu-item',
                    page: false,
                });
            }
        }
        /**** THE SCROLLSLOW - END ****/




        $g.addClassBodyByBrowser(); /** ADD BROWSER NAME IN BODY CLASSES **/

        /*******************************
        **** CUSTOM SCRIPTS - START ****
        *******************************/
        // $g.searchInit();

        $g.updateTopBar();

        /*$g.filtrationInit();
        setTimeout(function() {
            // console.log('load more');
            $('.grid-row').masonry($g.masonryArgs);
        }, 300);*/


    });

    $(window).on('scroll', function () {
        $g.updateTopBar();
    });

    $(window).on('load', function () {

    });

    $(window).resize(function () {

    });
}(jQuery));


},{"./modules/topbar.js":2,"./plugins/browser.js":3,"./plugins/scrollslow.js":4}],2:[function(require,module,exports){
$g.updateTopBar = function () {

    var $ = jQuery;
    var scrollTop = $(window).scrollTop();
    var header = $('.header');
    var headerHeight = header.outerHeight();

    //if (scrollTop > headerHeight) {
    if (scrollTop > 0) {
        header.addClass('header--scrolling').addClass('slideInDown');
    } else {
        header.removeClass('header--scrolling').removeClass('slideInDown');
    }
};
},{}],3:[function(require,module,exports){
$g.addClassBodyByBrowser = function() {
    var $ = jQuery;
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
            $('body').addClass('b-is-chrome');
        } else {
            $('body').addClass('b-is-safari');
        }
    } else if (ua.indexOf('firefox') > -1) {
        $('body').addClass('b-is-firefox');
    }
};

$g.ajaxCheckRun = function(fn_name) {
    var statusAA = false;
    $.each(WP.ajaxRun, function( i, n ) {
        if(fn_name == n) {
            statusAA = true;
        }
    });
    return statusAA;
}
},{}],4:[function(require,module,exports){
/** scrollSlow 1.8 by scriptos.eu **/
/* test in jQuery v1.11.3 */
$g.scrollSlow=function(o){var h=jQuery,e=1e3,s=0,r="active",t="",i="",n="",c="section[id]",d=!1;o.speed&&(e=o.speed),o.top&&(s=o.top),o.active&&(r=o.active),o.link&&(t=o.link),o.element&&(i=o.element+" "),o.page&&(n=o.page),o.ids&&(c=o.ids);var p=i+"a"+t;h(p+'[href*="#"]:not([href="#"])').click(function(){if(location.pathname.replace(/^\//,"")==this.pathname.replace(/^\//,"")&&location.hostname==this.hostname){var o=h(this.hash);if((o=o.length?o:h("[name="+this.hash.slice(1)+"]")).length)return h("html, body").animate({scrollTop:o.offset().top-s},e),!1}}),scrollChange=function(){var o=h(window).scrollTop(),i=new Array;h(c).each(function(){var o=h(this).attr("id"),e=h(this).height(),t=Math.round(h(this).offset().top);i.push({id:o,height:e,topbox:t})}),h(p).removeClass(r);for(var e=0;e<i.length;e++){var t,n,l=i[e].topbox+i[e].height+o,a=o+s+1;a>=i[e].topbox&&o<l&&(h(p).removeClass(r),h(p+'[href*="#'+i[e].id+'"]').addClass(r),i[t=e+1]&&(d=i[t].topbox+i[t].height),n=h(window).scrollTop()+h(window).height(),l-o<=a-s&&h(p).removeClass(r),d==h(document).height()&&h(document).height()==n&&(h(p).removeClass(r),h(p+'[href*="#'+i[t].id+'"]').addClass(r)))}};i=window.location.hash;i&&(t=h(i).offset(),h(i).length&&0==t.top?h(window).scrollTop(0):h(i).length&&h(window).scrollTop()!=t.top&&(1==n?h("html, body").animate({scrollTop:t.top-s+1},e):h(window).scrollTop(t.top-s+1))),scrollChange(),h(window).scroll(function(){scrollChange()})};
/** scrollSlow by scriptos.eu **/
},{}]},{},[1])